// import MiniSignal from 'mini-signals';
// import { clone } from '../utils';

/**
 *
 * Storage
 *
 * @export
 * @class Storage
*/
export default class Storage {
	/**
     * Creates an instance of Storage.
     *
     * @param {string} [id='sk.enea']
*/
	constructor(id = 'sk.enea') {
		this.id = id;

		this.data = {};

		this.useFallback = !this.canUseLocalStorage();

		this.useNative = (window.Cocoon && window.NativeStorage);

		// this.createSignals();
	}

	/**
     *
     * canUseLocalStorage
     *
     * @returns {boolean}
*/
	canUseLocalStorage() {
		const test = 'sk.enea.local.storage.test';

		try {
			localStorage.setItem(test, test);

			localStorage.removeItem(test);

			return true;
		} catch (e) {
			return false;
		}
	}

	/**
     *
     * createSignals
     *
*/
	createSignals() {
		this.signals = typeof this.signals !== 'undefined' ? this.signals : {};

		this.signals.ready = new MiniSignal();

		this.signals.save = new MiniSignal();
	}

	/**
     *
     * destroySignals
     *
*/
	destroySignals() {
		for (const i in this.signals) {
			if (this.signals[i] instanceof MiniSignal) {
				this.signals[i].detachAll();
			}
		}

		this.signals = null;
	}

	/**
     *
     * init
     *
*/
	init() {
		if (this.useFallback) {
			// eslint-disable-next-line no-console
			console.warn('ENEA.Storage : using fallback...');
		}

		if (this.useNative) {
			// eslint-disable-next-line no-console
			console.warn('ENEA.Storage : using native...');

			this.initNative();
		} else {
			// this.signals.ready.dispatch();
		}
	}

	/**
     *
     * initNative
     *
*/
	initNative() {
		window.NativeStorage.getObject(this.id,

			(data) => {
				if (typeof data === 'object' && data !== null) {
					this.data = data;
				}

				// this.signals.ready.dispatch();
			},

			(error) => {
				// eslint-disable-next-line no-console
				console.warn(`ENEA.Storage : error code (${error.code})`);

				if (error.exception !== '') {
					// eslint-disable-next-line no-console
					console.warn(`ENEA.Storage : (${error.exception})`);
				}

				// eslint-disable-next-line no-console
				console.warn('ENEA.Storage : switching to fallback...');

				this.useFallback = true;

				this.useNative = false;

				// this.signals.ready.dispatch();
			});
	}

	/**
     *
     * get
     *
     * @param {string} key
     * @param {any} defaultValue
     * @returns {any}
*/
	get(key, defaultValue) {
		if (this.useNative || this.useFallback) {
			if (this.data !== null && this.data[key] !== 'undefined') {
				return this.data[key];
			}
		} else {
			const val = localStorage.getItem(`${this.id}.${key}`);

			if (val !== null) {
				return val;
			}
		}

		return defaultValue;
	}

	/**
     *
     * set
     *
     * @param {string} key
     * @param {any} value
*/
	set(key, value) {
		if (this.useNative) {
			this.data[key] = value;

			window.NativeStorage.setItem(this.id, this.data,
				() => {
					// do nothing
				},

				(error) => {
					// eslint-disable-next-line no-console
					console.warn(`ENEA.Storage : set error (${error})`);
				}
			);
		} else if (this.useFallback) {
			this.data[key] = value;
		} else {
			localStorage.setItem(`${this.id}.${key}`, value);
		}
	}

	/**
     *
     * remove
     *
     * @param {string} key
*/
	remove(key) {
		if (this.useNative) {
			if (this.data !== null && this.data[key] !== 'undefined') {
				delete this.data[key];
			}

			window.NativeStorage.remove(this.id,
				() => {
					// do nothing
				},

				(error) => {
					// eslint-disable-next-line no-console
					console.warn(`ENEA.Storage : remove error (${error})`);
				}
			);
		} else if (this.useFallback) {
			delete this.data[key];
		} else {
			localStorage.removeItem(`${this.id}.${key}`);
		}
	}

	/**
     *
     * has
     *
     * @param {string} key
     * @returns {boolean}
*/
	has(key) {
		if (this.useNative || this.useFallback) {
			if (this.data !== null && this.data[key] !== 'undefined') {
				return true;
			}

			return false;
		}

		return localStorage.getItem(`${this.id}.${key}`) !== null;
	}

	/**
     *
     * removeAllById
     *
*/
	removeAllById() {
		if (this.useNative || this.useFallback) {
			for (const k in this.data) {
				this.remove(k);
			}

			this.data = {};
		} else {
			for (let i = localStorage.length - 1; i >= 0; i--) {
				const key = localStorage.key(i);

				if (key.indexOf(`${this.id}.`) !== -1) {
					localStorage.removeItem(key);
				}
			}

			this.data = {};
		}
	}

	/**
     *
     * clone
     *
     * @param {object} obj
     * @returns {object}
*/
	clone(obj) {
		return JSON.parse(JSON.stringify(obj));
	}

	/**
     *
     * setData
     *
     * @param {object} [data={}]
*/
	setData(data = {}) {
		this.data = this.clone(data);
	}

	/**
     *
     * load
     *
*/
	load() {
		this.data = this.has('data') && !this.useFallback ? JSON.parse(this.get('data')) : {};
	}

	/**
     *
     * save
     *
     * @param {any} additional
*/
	// eslint-disable-next-line no-unused-vars
	save(additional) {
		if (!this.useFallback) {
			this.set('data', JSON.stringify(this.data));
		}

		// this.signals.save.dispatch(this.data, additional);
	}

	/**
     *
     * doSeppuku
     *
*/
	doSeppuku() {
		// this.destroySignals();

		this.data = {};
	}
}
